import { io } from 'socket.io-client';
import { auth } from '../config/firebase';

// API ile aynı mantık: yayında nginx aynı origin üzerinden yönlendirir.
const isLocalDev = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || (isLocalDev ? 'http://127.0.0.1:3000' : window.location.origin);

let socket = null;

/**
 * Socket.IO bağlantısını (varsa mevcut olanı) döndürür.
 * Sunucu handshake sırasında Firebase ID token'ı bekliyor.
 */
export async function getSocket() {
  const user = auth.currentUser;
  if (!user) return null;

  if (socket && socket.connected) return socket;

  if (socket) {
    socket.connect();
    return socket;
  }

  socket = io(SOCKET_URL, {
    // Token bir saatte bir geçersizleşiyor; her bağlantı denemesinde
    // tazesi alınmazsa yeniden bağlanma "id-token-expired" ile reddedilir.
    auth: (cb) => {
      const current = auth.currentUser;
      if (!current) return cb({});
      current.getIdToken().then(
        (token) => cb({ token }),
        () => cb({})
      );
    },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000
  });

  socket.on('connect_error', (err) => {
    console.error('Socket.IO baglanti hatasi:', err.message);
  });

  return socket;
}

/**
 * Bir sohbet odasındaki yeni mesajları dinler.
 * Geriye aboneliği sonlandıran bir fonksiyon döner.
 */
export function subscribeToRoom(roomId, onNewMessage) {
  let activeSocket = null;
  let cancelled = false;

  const handler = (msg) => {
    if (!msg || msg.roomId !== roomId) return;
    onNewMessage(msg);
  };

  const onConnect = () => {
    if (!cancelled && activeSocket) activeSocket.emit('join_room', roomId);
  };

  getSocket().then((s) => {
    if (!s || cancelled) return;
    activeSocket = s;
    s.emit('join_room', roomId);
    s.on('new_message', handler);
    s.on('connect', onConnect);
  });

  return () => {
    cancelled = true;
    if (activeSocket) {
      activeSocket.emit('leave_room', roomId);
      activeSocket.off('new_message', handler);
      activeSocket.off('connect', onConnect);
    }
  };
}

/**
 * Panelin tamamını ilgilendiren mesaj hareketlerini dinler (cevapsız listesi
 * gibi). Sunucu bu olayı yalnızca admin kanalına yayınlar.
 * Geriye aboneliği sonlandıran bir fonksiyon döner.
 */
export function subscribeToAdminActivity(onActivity) {
  let activeSocket = null;
  let cancelled = false;

  getSocket().then((s) => {
    if (!s || cancelled) return;
    activeSocket = s;
    s.on('admin_chat_activity', onActivity);
  });

  return () => {
    cancelled = true;
    if (activeSocket) activeSocket.off('admin_chat_activity', onActivity);
  };
}

/**
 * Gönderi / hikaye oluşturma-silme olaylarını dinler.
 * Sunucu yalnızca admin kanalına 'content_updated' yayınlar.
 */
export function subscribeToContentUpdates(onUpdate) {
  let activeSocket = null;
  let cancelled = false;

  getSocket().then((s) => {
    if (!s || cancelled) return;
    activeSocket = s;
    s.on('content_updated', onUpdate);
  });

  return () => {
    cancelled = true;
    if (activeSocket) activeSocket.off('content_updated', onUpdate);
  };
}

export default getSocket;
